module.exports = __webpack_public_path__ + "svg/illustration-estatePlanner.85c797b.svg";